@if (company(); as company) {
  <span
    >{{ company.name | prettyCompanyName }}
    @if (showOrgNr()) {
      <span
        >(<nk-company-org-nr
          [company]="company"
          [showFlag]="showFlag()"
          [disableClipboardCopy]="disableClipboardCopy()"></nk-company-org-nr
        >)</span
      >
    }
  </span>
}
